<template>
<div>
  <div class="row">
    <template v-if="data_available">
      <div class="col-4">
        <GenericBarChart
          :data="year_data"
          label-field="year"
          contracts-field="contracts"
          amount-field="amount"
          title-x="Año"
        />
      </div>
      <div class="col-4">
        <GenericBarChart
          :data="cpv_data"
          label-field="key"
          contracts-field="contracts"
          amount-field="amount"
          title-x="CPV"
        />
      </div>
      <div class="col-4">
        <GenericBarChart
          :data="contract_type_data"
          label-field="key"
          contracts-field="contracts"
          amount-field="amount"
          title-x="Tipo de contrato"
        />
      </div>
      <div class="col-4">
        <GenericBarChart
          :data="tenders_per_location"
          label-field="key"
          contracts-field="contracts"
          amount-field="amount"
          title-x="Localizacion"
        />
      </div>
      <div class="col-4">
        <GenericBarWithGoals
          :data="top_contracting_parties"
          label-field="key"
          contracts-field="contracts"
          amount-field="amount"
          goal-field="bajaPct"
          title-x="Top 10 contratistas por importe"
        />
      </div>
    </template>
    <template v-else>
      <p>No hay datos disponibles para mostrar los gráficos.</p>
    </template>
  </div>
  <div class="row">
    <div class="col-12 mb-3 text-left">
      <button  class="btn btn-secondary"
        @click="filtersVisibility = !filtersVisibility"
        aria-controls="procurement-filters-collapse"
        :aria-expanded="filtersVisibility ? 'true' : 'false'">
        <i class="fas fa-filter ml-1" ></i>
        <span v-if="!filtersVisibility"> Mostrar filtros</span><span v-else> Ocultar filtros</span>
      <i :class="!filtersVisibility ?'fas fa-angle-down ml-1' : 'fas fa-angle-up ml-1'" ></i>
      </button>
      <b-collapse v-model="filtersVisibility" class="collapse-tags" id="procurement-filters-collapse">
        <div class="stripe-light  p-3 border">
        <input type="text" class="form-control"
          id="search" placeholder="Filtrar por texto"
          v-model="searchTerms" @keyup.enter="getProcurementPartyTenderResults()" v-debounce:500ms="getTenderResultsDebounceSTerms">
        <procurement-filters
          ref="procurement_filters"
          v-on:setFilters="setFilters($event)"
          v-on:yearsChanged="filterYearsChanged($event)"
          :excludedFilters="['status', 'awardee_party', 'tender_submission_deadline']"/>
          </div>
      </b-collapse>
    </div>
  </div>
  <div class="row">
    <div class="col-6 text-left">
      <paginationComponent
        id="tender-results-pagination"
        :currentPage="current_page"
        :totalPages="total_pages"
        v-on:next-page-tender-results-pagination="changeTenderResultPage($event)"/>
    </div>
    <div class="col-6 text-right">
      <button v-b-tooltip.hover title="Exportar a excel" class="btn  btn-secondary ml-2 mr-2" @click="openExcelExportModal()">
        <i class="fas fa-file-excel"/> Exportar
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div v-if="tenderResultYears.length > 0">
        Mostrando los años {{ tenderResultYears.join(", ") }}
      </div>
      <div class="table-responsive">
      <table class="table text-left bg-white">
        <thead class="corporative">
          <tr>
            <th scope="col"> Fecha Publicación Licitación </th>
            <th scope="col"> Fecha Adjudicación </th>
            <th scope="col"> Resumen Licitación </th>
            <th scope="col"> Título </th>
            <th scope="col"> CPV </th>
            <th scope="col"> Lugar de Ejecución </th>
            <th scope="col"> Importe Total Licitación</th>
            <th scope="col"> Importe Total Adjudicación</th>
            <th scope="col"> Diferencia con importe licitado </th>
            <th scope="col"> Lotes / Razón de adjudicación </th>
            <th scope="col"> Órgano o Entidad </th>
          </tr>
        </thead>
        <tbody>
          <TenderResultRow :tender="tender_result" v-for="(tender_result, index) in tender_results"
            v-bind:key="`tender_result_ ${index}`" />
        </tbody>
      </table>
      </div>
    </div>
    <b-modal
      ref="excel-export-modal"
      hide-footer>
      <template #modal-title>
        <h2 class="corporative-principal">Exportar adjudicaciones a Excel </h2>
      </template>
        Adjudicaciones a exportar:
        <b-form-select class="my-2" v-model="exportNumber" :options="exportOptions"></b-form-select>
        <button class="btn btn-secondary mt-2" @click="exportExcel()"> Exportar  <i class="fas fa-file-export"></i></button>
    </b-modal>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import procurementService from '@/_services/procurement.service';
import procurementMixin from '@/_mixins/procurement.mixin';
import excelExporter from '@/_helpers/excel_exporter';
import paginationComponent from '@/components/helpers/pagination.vue';
import procurementChartsMixin from '@/_mixins/procurement_charts.mixin';
import GenericBarChart from '@/components/helpers/generic_bar_chart.vue';
import GenericBarWithGoals from '@/components/helpers/generic_bar_goals_chart.vue';
import procurementFilters from './procurement_filters.vue';
import TenderResultRow from './procurement_party_tender_results_row.vue';


export default {
  name: 'procurementPartyTenderResultsComponent',
  mixins: [procurementMixin, procurementChartsMixin],
  props: ['party'],
  components: {
    GenericBarChart,
    GenericBarWithGoals,
    paginationComponent,
    procurementFilters,
    TenderResultRow,
  },
  data() {
    return {
      filtersVisibility: false,
      tender_results: [],
      projects_stats: {},
      current_page: 1,
      total_results: 0,
      total_pages: 0,
      tenderResultYears: [],
      searchTerms: '',
      currentFilters: {},
      exportNumber: 25,
      exportOptions: [
        { value: 25, text: '25 (Página actual)' },
        { value: 50, text: '50' },
        { value: 75, text: '75' },
        { value: 100, text: '100' },
        { value: 1000, text: 'Todas (máximo 1000)' },
      ],
    };
  },
  mounted() {
    this.getProcurementPartyTenderResults();
  },
  computed: {

  },
  methods: {
    filterYearsChanged(years) {
      const yearsToAdd = years.filter(value => !this.tenderResultYears.includes(value));
      const yearsToRemove = this.tenderResultYears.filter(value => !years.includes(value));
      const yearsToToggle = yearsToAdd.concat(yearsToRemove);

      const year_indexes = [];
      yearsToToggle.map((year) => {
        const index = this.chartConfig.options.labels.findIndex(label => label === year);
        if (index >= 0) {
          year_indexes.push(index);
        }
        return index;
      });

      for (let i = 0; i < year_indexes.length; i += 1) {
        this.$refs.apexchart.toggleDataPointSelection(0, year_indexes[i]);
      }
    },
    addYear(year, fromUserClick = true) {
      const index = this.tenderResultYears.findIndex(el => el === year);
      if (index > -1) {
        // Already there, remove
        this.tenderResultYears.splice(index, 1);
      } else {
        this.tenderResultYears.push(year);
      }

      if (fromUserClick) {
        this.$refs.procurement_filters.setDateYears(this.tenderResultYears);
      }
    },
    changeTenderResultPage(page) {
      this.getProcurementPartyTenderResults(page);
    },
    exportExcel() {
      const filename = `${this.$moment().format('YYYY_MM_DD')}_exportacion_adjudicaciones.xlsx`;

      const params = {
        years: this.tenderResultYears,
        filters: {
          ...this.currentFilters,
          awardee_party_ids: [this.party.id],
        },
      };

      if (this.searchTerms !== '') {
        params.searchTerms = this.searchTerms;
      }

      procurementService.getProcurementPartyTenderResults(this.$route.params.id, params).then((res) => {
        const { tender_results } = res.data;
        excelExporter.saveProcurementTenderResults(tender_results, this.party.name, filename);
      });
    },
    getTenderResultsDebounceSTerms() {
      this.getProcurementPartyTenderResults();
    },
    getProcurementPartyTenderResults(page = 1) {
      const params = {
        page,
        filters: {
          ...this.currentFilters,
          date: {
            years: this.tenderResultYears,
          },
        },
      };

      if (this.searchTerms !== '') {
        params.searchTerms = this.searchTerms;
      }


      const self = this;
      procurementService.getProcurementPartyTenderResults(this.$route.params.id, params).then((res) => {
        const { results } = res.data;
        const { total_results, total_pages, current_page } = res.data.metadata;

        Vue.set(self, 'tender_results', results);
        if (current_page === 1 && res.data.aggs) {
          Vue.set(self, 'projects_stats', res.data.aggs);
        }
        self.total_results = total_results;
        self.total_pages = total_pages;
        self.current_page = current_page;
      });
    },
    setFilters(event) {
      Vue.set(this, 'currentFilters', event.filters);
      this.getProcurementPartyTenderResults();
    },
    openExcelExportModal() {
      this.$refs['excel-export-modal'].show();
    },
  },
};
</script>

<style scoped>

.party{
  padding: 30px;
}
h1{
  display:inline-block;
  margin-left: 5px;
}
.fa-external-link-alt {
  color:#000000;
}
.fa-external-link-alt:hover {
  cursor:pointer;
  color:#4953CF;
}
</style>
